module.exports = __webpack_public_path__ + "img/estp.2c949ed3.png";